import {
  BottomSheetBody,
  BottomSheetFooter,
  BottomSheetHeader,
  BottomSheetHeaderTitle,
  EmptyState,
} from "@opensea/ui-kit"
import { useMountEffect } from "@opensea/ui-kit/hooks"
import { useTranslations } from "use-intl"
import { useTrackEvent } from "../../providers/TrackEventProvider"
import { FlowActions, FlowState } from "../../stores/flowStore"
import { Button } from "../Button"
import { MAX_PRICE_CHANGE_PERCENTAGE } from "./constants"
import type { PriceValidationResult } from "./usePriceValidation"

type Props = {
  priceValidation: PriceValidationResult
}

export function PriceChangeError({ priceValidation }: Props) {
  const t = useTranslations("wallet.PriceChangeError")

  const trackEvent = useTrackEvent()
  useMountEffect(() => {
    trackEvent("Price Changed Error Shown", {
      flow: FlowState.flow?.type,
      priceValidation,
    })
  })

  return (
    <>
      <BottomSheetHeader>
        <BottomSheetHeaderTitle hidden={true}>
          {t("title")}
        </BottomSheetHeaderTitle>
      </BottomSheetHeader>
      <BottomSheetBody>
        <EmptyState
          description={t("description", {
            percentage: MAX_PRICE_CHANGE_PERCENTAGE,
          })}
          title={t("title")}
          variant="no-results"
        />
      </BottomSheetBody>
      <BottomSheetFooter className="items-center">
        <Button
          className="w-fit"
          onClick={FlowActions.endFlow}
          variant="secondary"
        >
          {t("close")}
        </Button>
      </BottomSheetFooter>
    </>
  )
}
